// extracted by mini-css-extract-plugin
export var body = "V_c";
export var footer = "V_cC";
export var footerText = "V_cD";
export var section = "V_j";
export var title = "V_g";